import { render, staticRenderFns } from "./XSelectUserByDepModal.vue?vue&type=template&id=567b3090&scoped=true&"
import script from "./XSelectUserByDepModal.vue?vue&type=script&lang=js&"
export * from "./XSelectUserByDepModal.vue?vue&type=script&lang=js&"
import style0 from "./XSelectUserByDepModal.vue?vue&type=style&index=0&id=567b3090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567b3090",
  null
  
)

export default component.exports